import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import AiConfigPage from './pages/AiConfigPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import UsersPage from './pages/UsersPage';
import './App.css';

/**
 * Wurzelkomponente mit Routing (React Router DOM 6) und Auth-Context.
 *
 * Routen:
 * - "/login"            Login (frei zugaenglich)
 * - "/auth/callback"    OAuth-Callback (frei zugaenglich)
 * - "/"                 Dashboard (geschuetzt, im AppLayout mit Sidebar)
 * - "/benutzer"         Benutzerverwaltung (geschuetzt, im AppLayout mit Sidebar)
 * - "/ki-konfiguration" KI-Konfiguration je Mandant (geschuetzt, im AppLayout mit Sidebar)
 * - "*"                 404-Seite (ohne Layout)
 */
function App(): React.JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<AppLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="benutzer" element={<UsersPage />} />
              <Route path="ki-konfiguration" element={<AiConfigPage />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
